<template>
    <section>
        <div class="banner_box">
            <!-- <img src="../../assets/aboutUs/aboutus.png" alt="海马行"> -->
        </div>
        <div>
            <div class="tab_box">
                <ul>
                    <li @click="introCompany" :class="{tab1: line1}">
                        公司介绍
                        <span class="border_line" :class="{border_line1: line1}"></span>
                    </li>
                    <li @click="culture" :class="{tab2: line2}">
                        企业文化
                        <span class="border_line" :class="{border_line2: line2}"></span>
                    </li>
                    <li @click="teamIntro" :class="{tab3: line3}">
                        团队介绍
                        <span class="border_line" :class="{border_line3: line3}"></span>
                    </li>
                    <li @click="connectUs" :class="{tab4: line4}">
                        联系我们
                        <span class="border_line" :class="{border_line4: line4}"></span>
                    </li>
                </ul>
            </div>
            <div class="content_box">
                <!-- 公司介绍 -->
                <div v-show="contentVal=='company'" class="introCompany_box">
                    <div class="text_content">
                        <p>北京思创银联科技股份有限公司（以下简称思银股份）于2004年诞生于中国硅谷，2012 年公司成功登陆新三板，并成为创新层旗舰公司。自2016年起，思创银联以建设民营加油站产业联盟为愿景，为车主用户提供贴心优质的出行服务为目标，联合工商银行，交通银行等多家金融机构，积极拓展面向民营加油站的金融场景建设，并且组建海马行平台开发团队，致力于智慧油站及车主用户APP的平台开发。平台旨在整合加油站业务数据、交易数据及用户数据，并希望通过和银行的产品运营合作，提供基于民营加油站的金融场景入口。通过交易沉淀资金，金融产品销售、集采大贸业务、培训咨询服务等产生利润收入。进而拓展到汽车后市场和车主出行服务领域，为油站及车主用户提供增值服务，最终建立基于民营加油站及车主用户的成品油行业联盟。</p>
                    </div>
                    <div class="img_content">
                        <img src="../../assets/aboutUs/prd.jpg" alt="海马行">
                    </div>
                </div>
                <!-- 企业文化 -->
                <div v-show="contentVal=='culture'" class="culture_box">
                    <div class="part1">
                        <div class="img_box">
                            <img src="../../assets/aboutUs/01.png" alt="海马行">
                        </div>
                        <div class="below_box">
                            <p>愿景</p>
                            <div>建设民营加油站产业联盟，实现加油站全业务互联网模式，成为用户最信任的服务平台</div>
                        </div>
                    </div>
                    <div class="part2">
                        <div class="img_box">
                            <img src="../../assets/aboutUs/02.png" alt="海马行">
                        </div>
                        <div class="below_box">
                            <p>使命</p>
                            <div>打破传统，重新定义油站行业，用科技和运营赋能加油站</div>
                        </div>
                    </div>
                    <div class="part3">
                        <div class="img_box">
                            <img src="../../assets/aboutUs/03.png" alt="海马行">
                        </div>
                        <div class="below_box">
                            <p>核心价值</p>
                            <div>突破、创新、思考</div>
                        </div>
                    </div>
                    <div class="part4">
                        <div class="img_box">
                            <img src="../../assets/aboutUs/04.png" alt="海马行">
                        </div>
                        <div class="below_box">
                            <p>经营理念</p>
                            <div>一切皆以提升用户价值为中心</div>
                        </div>
                    </div>
                </div>
                <!-- 团队介绍 -->
                <div v-show="contentVal=='team'" class="team_box">
                    <div class="manage_team">
                        <div class="manage_img">
                            <img src="../../assets/aboutUs/010.png" alt="">
                        </div>
                        <div class="manage_content">
                            <p>管理团队</p>
                            <div>精英团队，团队中的成员均为国内外知名公司的优秀人才，核心管理者从事油品行业多年，拥有多年油品行业市场营销管理及战略执行经验。高管团队是具备等全球领先的互联网从业经验的领军人物。同时拥有从业超过15年，对成品油行业有着深入研究的顾问专家。</div>
                        </div>
                    </div>
                    <div class="technology_team">
                        <div class="technology_content">
                            <p>技术团队</p>
                            <div>公司拥有技术人员50+，部分成员来自BAT等大型互联网公司，核心成员为思银股份多年老员工组成，团队稳定技术硬，年轻有活力。</div>
                        </div>
                        <div class="technology_img">
                            <img src="../../assets/aboutUs/09.png" alt=""><img src="../../assets/aboutUs/08.png" alt="">
                        </div>
                    </div>
                </div>
                <!-- 联系我们 -->
                <div v-show="contentVal=='connect'" class="connect">
                    <div id="bd_map"></div>
                    <div class="connect_type">
                        <div class="box">
                            <div class="phone_img_box">
                                <img src="../../assets/aboutUs/06.png" alt="">
                            </div>
                            <p>电话</p>
                            <div class="content">010-59519607</div>
                        </div>
                        <div class="box">
                            <div class="add_img_box">
                                <img src="../../assets/aboutUs/05.png" alt="">
                            </div>
                            <p>公司地址</p>
                            <div class="content">北京市海淀区上地三街金隅嘉华大厦D座909</div>
                        </div>
                        <div class="box">
                            <div class="email_img_box">
                                <img src="../../assets/aboutUs/07.png" alt="">
                            </div>
                            <p>电子邮箱</p>
                            <div class="content">hmjy@strongunion.com.cn</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        data() {
            return {
                line1: true,
                line2: false,
                line3: false,
                line4: false,
                contentVal: 'company',
                map: null,
            }
        },
        methods: {
            creatMap() {
                // 创建Map实例
                this.map = new BMap.Map("bd_map", {minZoom:8,maxZoom:19});
                var point = new BMap.Point(116.314403, 40.0428);
                this.map.centerAndZoom(point,15);
                //添加鼠标滚动缩放
                this.map.enableScrollWheelZoom(true);

                //添加缩放平移控件
                // this.map.addControl(new BMap.NavigationControl());

                //添加比例尺控件
                // this.map.addControl(new BMap.ScaleControl());

                //添加地图类型控件
                // this.map.addControl(new BMap.MapTypeControl());

                //设置标注的图标
                // var icon = new BMap.Icon("img/icon.jpg",new BMap.Size(100,100));
                //设置标注的经纬度
                var marker = new BMap.Marker(new BMap.Point(116.314403, 40.0428));
                //把标注添加到地图上
                this.map.clearOverlays();
                this.map.addOverlay(marker);
                this.map.panBy(500, 210);

            },
            introCompany(){
                this.line1 = true;
                this.line2 = false;
                this.line3 = false;
                this.line4 = false;
                this.contentVal = 'company';
            },
            culture(){
                this.line1 = false;
                this.line2 = true;
                this.line3 = false;
                this.line4 = false;
                this.contentVal = 'culture';
            },
            teamIntro(){
                this.line1 = false;
                this.line2 = false;
                this.line3 = true;
                this.line4 = false;
                this.contentVal = 'team';
            },
            connectUs(){
                this.line1 = false;
                this.line2 = false;
                this.line3 = false;
                this.line4 = true;
                this.contentVal = 'connect';
            }
        },
        mounted() {
            this.creatMap();
        },
    }
</script>
<style scoped>
    .banner_box{
        width: 100%;
        height: 400px;
        background: url(../../assets/aboutUs/aboutus.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .banner_box img{
        width: 100%;
        vertical-align: bottom;
    }
    .tab_box{
        border-bottom: 1px solid #F6F6F7;
        height: 80px;
        margin-bottom: 64px;
    }
    .tab_box ul{
        width: 1200px;
        margin: 0 auto;
    }
    .tab_box ul li{
        display: inline-block;
        position: relative;
        font-size: 16px;
        color: #666;
        line-height: 80px;
        width: 300px;
        cursor: pointer;
    }
     .tab_box ul li:hover{
        color: #0094eb;
     }
    .border_line{
        position: absolute;
        bottom: 0;
        left: 90px;
        right: 0;
        width: 120px;
        font-size: 0;
        border-bottom: 3px solid transparent;
    }
    .border_line1, 
    .border_line2, 
    .border_line3, 
    .border_line4{
        border-bottom: 3px solid #0094eb;
    }
    .tab_box ul li.tab1, 
    .tab_box ul li.tab2, 
    .tab_box ul li.tab3, 
    .tab_box ul li.tab4{
        color: #0094eb;
    }
    .content_box{
        width: 1200px;
        margin: 0 auto;
        margin-bottom: 64px;
    }
    /* 公司介绍 */
    .introCompany_box .text_content, .introCompany_box .img_content{
        display: inline-block;
        vertical-align: top;
    }
    .introCompany_box .text_content{
        width: 580px;
        padding-right: 12px;
        font-size: 16px;
        color: #666;
        line-height: 32px;
        text-align: left;
        padding-top: 12px;
    }
    /* 企业文化 */
    .part1, .part2, .part3, .part4{
        display: inline-block;
        vertical-align: top;
        width: 285px;
        height: 460px;
        margin-right: 20px;
    }
    .part4{
        margin-right: 0;
    }
    .img_box img{
        vertical-align: bottom;
    }
    .below_box{
        height: 200px;
        border: 1px solid #E8E8EB;
        border-top: none;
        padding: 32px 28px 0;
    }
    .below_box p{
        color: #333;
        font-size: 24px;
        margin-bottom: 12px;
    }
    .below_box div{
        font-size: 16px;
        color: #666;
    }
    /* 团队介绍 */
    /* 管理团队 */
    .manage_team{
        margin-bottom: 100px;
        text-align: left;
    }
    .manage_img, .manage_content{
        display: inline-block;
        vertical-align: top;
        /* text-align: left; */
    }
    .manage_img{
        font-size: 0;
    }
    .manage_content{
        padding-top: 100px;
        width: 600px;
    }
    .manage_content p{
        display: inline-block;
        margin-left: 114px;
        font-size: 28px;
        line-height: 64px;
        border-bottom: 2px solid #333;
        margin-bottom: 40px;
    }
    .manage_content div{
        margin-left: 180px;
        font-size: 16px;
        color: #666;
        line-height: 28px;
    }
    /* 技术团队 */
    .technology_team{
        position: relative;
        height: 460px;
        width: 100%;
        background-color: #0094eb;
        color: #fff;
        padding-left: 184px;
    }
    .technology_content{
        width: 340px;
        text-align: left;
    }
    .technology_content p{
        display: inline-block;
        font-size: 24px;
        padding-top: 72px;
        line-height: 56px;
        border-bottom: 2px solid #ffffff;
        margin-bottom: 48px;
    }
    .technology_content div{
        font-size: 16px;
    }
    .technology_img{
        /* display: inline-block; */
        position: absolute;
        top: -70px;
        left: 580px;
    }
    .technology_img img{
        vertical-align: bottom;
        margin-right: 38px;
        width: 230px;
    }
    /* 联系我们 */
    #bd_map{
        width: 1000px;
        height: 420px;
        border: 1px solid #ccc;
        margin: 0 auto;
    }
    .connect_type{
        padding-top: 48px;
    }
    .box{
        display: inline-block;
        vertical-align: top;
        width: 400px;
    }
    .phone_img_box, .add_img_box, .email_img_box{
        height: 46px;
    }
    .box p{
        font-size: 20px;
        color: #333;
        margin: 40px 0;
    }
    .box .content{
        color: #666;
        font-size: 14px;
    }
</style>
